"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const EMediaKind_1 = require("../../../../enums/Project/Config/Media/EMediaKind");
const ValidationErrors_1 = require("../../../../enums/Validation/ValidationErrors");
const Custom_1 = __importDefault(require("../../../decorators/Custom"));
const IsUniqueLang_1 = require("../../../decorators/IsUniqueLang");
const I18nTextResource_1 = require("../../../I18nText/I18nTextResource");
const Resource_1 = __importDefault(require("../../../Resource"));
class MediaRequestResource extends Resource_1.default {
}
exports.default = MediaRequestResource;
__decorate([
    (0, class_validator_1.IsEnum)(EMediaKind_1.EMediaKind),
    (0, Custom_1.default)((kind, args) => (kind === EMediaKind_1.EMediaKind.URL && args.object.url !== undefined) || kind !== EMediaKind_1.EMediaKind.URL, {
        message: ValidationErrors_1.EValidationError.mediaUrlIsRequired,
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MediaRequestResource.prototype, "kind", void 0);
__decorate([
    (0, class_validator_1.IsUrl)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MediaRequestResource.prototype, "url", void 0);
__decorate([
    (0, class_validator_1.IsUrl)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MediaRequestResource.prototype, "previewImageUrl", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => I18nTextResource_1.I18nTextResource),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, IsUniqueLang_1.IsUniqueLang)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], MediaRequestResource.prototype, "caption", void 0);
